<template>
  <div class="giris" v-if="Proje">

    <a href="https://www.aidatim.com" class="logo tr"></a> <!--:class="$t('Root.1')"-->
    <router-view></router-view>
    <div class="footer">
      <!--a href="#" class="i18n" v-if="this.$i18n.locale=='en'" @click="setLocale('tr')">
          <small class="text-gri">Türkçe</small>
      </a>
      <a href="#" class="i18n" v-if="this.$i18n.locale=='tr'" @click="setLocale('en')">
          <small class="text-gri">English</small>
      </a-->
      <a v-if="Proje==='aidat'" href="https://www.aidatim.com/kisisel-verilerin-korunmasi-hakkinda-bilgilendirme"
         target="_blank">{{$t('Giris.13')}}</a>
      <a v-if="Proje==='aidat'" href="https://www.aidatim.com/kilavuz" target="_blank">{{$t('Giris.14')}}</a>
      <a v-if="Proje==='aidat'" href="https://www.aidatim.com/gizlilik-politikasi"
         target="_blank">{{$t('Giris.15')}}</a>
      <a v-if="Proje==='aidat'" href="https://www.aidatim.com/hizmet-sozlesmesi" target="_blank">{{$t('Giris.16')}}</a>
    </div>
    <div class="after">

      <a href="https://www.aidatim.com" class="logo tr"></a>
      <el-tag v-if="this.$store.getters.SubDomain=='v10'" style="position:relative;top:-20px"><i
        class="el-icon-trophy-1"></i> Back Office
      </el-tag>
      <el-tag v-if="this.$store.getters.SubDomain!='app' && this.$store.getters.SubDomain!='v10'"
              style="position:relative;top:-20px"><i class="el-icon-location"></i>
        <b>{{this.$store.getters.SubDomain}}</b> sunucusu
      </el-tag>
      <h1 v-if="this.$store.getters.SubDomain!='v10'">Yeni Nesil Yönetici Asistanı</h1>
      <h5 v-if="this.$store.getters.SubDomain!='v10'">Profesyonel ve detaylı yönetim anlayışını, anlaşılabilir ve kolay
        yöntemlerle sunuyor, şeffaf ve teknolojik
        hizmetler vermenizi sağlıyoruz.</h5>


    </div>

  </div>
</template>
<script>
  export default {
    data() {
      return {
        Proje: 'aidat'
      }
    },

    created() {

      //if (!localStorage.getItem('_aiLocale')) localStorage.setItem('_aiLocale', 'tr');
      //if (window.location.host.split('.')[1]) localStorage.setItem('_aiProje', window.location.host.split('.')[1]);
      //if (!localStorage.getItem('_aiProje')) localStorage.setItem('_aiProje', 'aidat');
      //this.Proje = localStorage.getItem('_aiProje');

    },
    methods: {
      /*
      setLocale(locale) {
        this.$i18n.locale = locale;
        localStorage.setItem('_aiLocale', locale);
        document.title = 'Aidatım | Yeni Nesil Yönetici Asistanı';
      }
       */
    }
  }
</script>
<style scoped>
  @import '../../assets/css/v10.giris.css';
</style>



// WEBPACK FOOTER //
// src/pages/Giris/_route.vue